var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-5"},[_c('b-overlay',{attrs:{"id":"overlay-background","show":_vm.Loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }